import { useState, useEffect } from 'react';

export function useIntersection(ref: React.RefObject<Element>): [boolean, boolean] {
  const [isVisibleOnLoad, setIsVisibleOnLoad] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const { top, bottom } = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    setIsVisibleOnLoad(bottom > 0 && top < viewportHeight);
  }, [ref]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return [isVisibleOnLoad, isVisible];
}
